import React from 'react'
import styles from './GlobalErrorModal.module.scss'

export interface GlobalErrorModalProps {
  title: string
  description: string
  primaryActionLabel: string
  onPrimaryAction: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
  isOpen?: boolean
}

export const GlobalErrorModal = ({
  title,
  description,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
  isOpen = true,
}: GlobalErrorModalProps) => {
  if (!isOpen) {
    return null
  }

  return (
    <div className={styles.backdrop} role='dialog' aria-modal='true'>
      <div className={styles.modal}>
        <p className={`mc-text--bold ${styles.title}`}>{title}</p>
        <p className={styles.description}>{description}</p>

        <div className={styles.actions}>
          <button className={styles.primaryButton} onClick={onPrimaryAction}>
            {primaryActionLabel}
          </button>
          {secondaryActionLabel && onSecondaryAction ? (
            <button
              className={styles.secondaryButton}
              onClick={onSecondaryAction}
            >
              {secondaryActionLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
